/**
 * @hidden
 */
export enum ExcelFolderTypes {
    RootExcelFolder,
    RootRelsExcelFolder,
    DocPropsExcelFolder,
    XLExcelFolder,
    XLRelsExcelFolder,
    ThemeExcelFolder,
    WorksheetsExcelFolder,
    WorksheetsRelsExcelFolder,
    TablesExcelFolder
}
/**
 * @hidden
 */
export enum ExcelFileTypes {
    RootRelsFile,
    AppFile,
    CoreFile,
    WorkbookRelsFile,
    ThemeFile,
    WorksheetFile,
    StyleFile,
    WorkbookFile,
    ContentTypesFile,
    SharedStringsFile,
    WorksheetRelsFile,
    TablesFile
}
